import { useTranslation } from "react-i18next";
import { Chip, StatusGlyph } from "@outpave/ds";
import type { ChipSize } from "@outpave/ds";
import ApiKeyStatus from "enums/ApiKeyStatus";
import {
  apiKeyStatusLabelKey,
  apiKeyStatusTone,
} from "utils/apiKeys/apiKeyStatus";

interface RenderApiKeyStatusProps {
  status: ApiKeyStatus;
  size?: ChipSize;
}

export const RenderApiKeyStatus: React.FC<RenderApiKeyStatusProps> = ({
  status,
  size = "sm",
}) => {
  const { t } = useTranslation();

  const labelKey = apiKeyStatusLabelKey(status);
  const tone = apiKeyStatusTone(status);

  // StatusGlyph is looked up by the untranslated label, so the glyph is right
  // in every locale while the label renders translated.
  return (
    <Chip
      tone={tone}
      size={size}
      leading={<StatusGlyph status={labelKey} tone={tone} />}
    >
      {t(labelKey)}
    </Chip>
  );
};

export default RenderApiKeyStatus;
